export enum VerticalAlignmentStyle {
  Top = 'Top',
  Center = 'Center',
  Bottom = 'Bottom',
}
